import { useEffect, useState } from "react";

const FINIX_JS_URL = "https://js.finix.com/v/1/finix.js";

let finixPromise: Promise<any> | null = null;

function loadFinixJs(): Promise<any> {
  if (finixPromise) return finixPromise;

  finixPromise = new Promise((resolve, reject) => {
    if ((window as any).Finix) {
      resolve((window as any).Finix);
      return;
    }

    const script = document.createElement("script");
    script.src = FINIX_JS_URL;
    script.async = true;
    script.onload = () => {
      if ((window as any).Finix) {
        resolve((window as any).Finix);
      } else {
        reject(new Error("Finix SDK failed to initialize"));
      }
    };
    script.onerror = () => {
      finixPromise = null;
      reject(new Error("Failed to load Finix SDK script"));
    };
    document.head.appendChild(script);
  });

  return finixPromise;
}

export function useFinixJs() {
  const [finix, setFinix] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadFinixJs()
      .then((sdk) => {
        setFinix(sdk);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setIsLoading(false);
      });
  }, []);

  return { finix, isLoading, error };
}
